module.exports = __webpack_public_path__ + "static/img/zaiban.6fd68faa.png";